import { render, staticRenderFns } from "./tj_caseTrend.vue?vue&type=template&id=48e648e4&scoped=true&"
import script from "./tj_caseTrend.vue?vue&type=script&lang=js&"
export * from "./tj_caseTrend.vue?vue&type=script&lang=js&"
import style0 from "./tj_caseTrend.vue?vue&type=style&index=0&id=48e648e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e648e4",
  null
  
)

export default component.exports